import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Text } from '@getpingback/realeza';

const components = {
  h1: ({ node, ...props }) => <Text tag="h1" color="gray" intensity={700} size={48} weight="bold" mb="16px" {...props} />,
  h2: ({ node, ...props }) => <Text tag="h2" color="gray" intensity={700} size={32} weight="bold" mb="16px" {...props} />,
  h3: ({ node, ...props }) => <Text tag="h3" color="gray" intensity={700} size={24} weight="bold" mb="16px" {...props} />,
  h4: ({ node, ...props }) => <Text tag="h4" color="gray" intensity={700} size={20} weight="bold" mb="8px" {...props} />,
  h5: ({ node, ...props }) => <Text tag="h5" color="gray" intensity={700} size={18} weight="bold" mb="8px" {...props} />,
  h6: ({ node, ...props }) => <Text tag="h6" color="gray" intensity={700} size={16} weight="semibold" mb="8px" {...props} />,
  p: ({ node, ...props }) => <Text tag="p" color="gray" intensity={700} size={14} weight="normal" mb="8px" {...props} />,
  ul: ({ node, ordered, ...props }) => (
    <ul style={{ listStyleType: 'disc', listStylePosition: 'inside', marginBottom: '16px', opacity: 0.85 }} {...props} />
  ),
  ol: ({ node, ordered, ...props }) => (
    <ol style={{ listStyleType: 'decimal', listStylePosition: 'inside', marginBottom: '16px', opacity: 0.85 }} {...props} />
  ),
  li: ({ node, ordered, ...props }) => <li style={{ marginBottom: '8px', opacity: 0.85, color: '#3f3f46' }} {...props} />,
  a: ({ node, ...props }) => <a style={{ color: '#9061F9', textDecoration: 'none' }} {...props} />,
};

export default function MarkdownFormat({ content }) {
  return (
    <ReactMarkdown components={components} className="markdown-format">
      {content}
    </ReactMarkdown>
  );
}
